import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from 'constants/api';
import { useState } from 'react';
import If from 'global/ErrorHandlers/If';
import {
  AuthModalContainer,
  CarouselContainer,
  RegisterInfoContainer,
  RegisterInfoDivider,
} from './styled';
import { AuthModalLoading, Carousel, VirtualTradingButton } from './components';
import { AuthModalProps, AuthModalType } from './types';
import useAuthModalStore from './store';

const { Flex, Text } = Common;

export default function RegisterTradingModal({ visible }: AuthModalProps) {
  const closeModal = useAuthModalStore((state) => state.closeModal);

  const [loading, setloading] = useState(false);

  return (
    <AuthModalContainer
      data-cy="register-trading-modal"
      visible={visible}
      centered
      width={751}
      onCancel={closeModal}
    >
      <Flex>
        <CarouselContainer justify="center" align="center">
          <Carousel />
        </CarouselContainer>
        <RegisterInfoContainer>
          <If condition={loading}>
            <AuthModalLoading />
          </If>

          <If condition={!loading}>
            <Text family="bold" size="24px" mb="8px">
              Mulai Investasi di Saham bersama Stockbit
            </Text>
            <Text mb="40px">
              Download aplikasi Stockbit untuk membuka akun trading dan mulai
              perjalanan investasimu dengan lebih mudah. Scan QR Code di bawah
              ini.
            </Text>
            <Flex justify="space-between" align="center">
              <Flex direction="column">
                <a
                  target="_blank"
                  href={GOOGLE_PLAY_URL}
                  rel="noopener noreferrer"
                >
                  <Image
                    alt="android"
                    src="/images/google-play.png"
                    style={{ height: '40px', marginBottom: '24px' }}
                  />
                </a>
                <a
                  target="_blank"
                  href={APP_STORE_URL}
                  rel="noopener noreferrer"
                >
                  <Image
                    alt="iOS"
                    src="/images/app-store.png"
                    style={{ height: '40px' }}
                  />
                </a>
              </Flex>
              <RegisterInfoDivider />
              <Image src="/img/stockbit-qr.svg" alt="stockbit app qr code" />
            </Flex>
            <Flex justify="space-between" align="center" mt="40px">
              <Text size="16px" color="#858585">
                Or Switch Platform
              </Text>
              <VirtualTradingButton
                title="Virtual Trading"
                type={AuthModalType.REGISTER}
                setLoading={setloading}
              />
            </Flex>
          </If>
        </RegisterInfoContainer>
      </Flex>
    </AuthModalContainer>
  );
}
